import { render, staticRenderFns } from "./RecetteEdition.vue?vue&type=template&id=0098844c&scoped=true&"
import script from "./RecetteEdition.vue?vue&type=script&lang=js&"
export * from "./RecetteEdition.vue?vue&type=script&lang=js&"
import style0 from "./RecetteEdition.vue?vue&type=style&index=0&id=0098844c&lang=scss&scoped=true&"
import style1 from "./RecetteEdition.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0098844c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0098844c')) {
      api.createRecord('0098844c', component.options)
    } else {
      api.reload('0098844c', component.options)
    }
    module.hot.accept("./RecetteEdition.vue?vue&type=template&id=0098844c&scoped=true&", function () {
      api.rerender('0098844c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Recettes/RecetteEdition.vue"
export default component.exports